import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" >
    <title>Icons/Search</title>
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Font_Home_Default" transform="translate(-1257.000000, -71.000000)" fill="#33333A" fillRule="nonzero">
            <g id="Group" transform="translate(0.000000, 40.000000)">
                <path d="M1264.67697,31 C1268.90747,31 1272.35173,34.4402699 1272.35173,38.6747553 C1272.35173,40.5984329 1271.64132,42.3584782 1270.46796,43.7074471 L1270.46796,43.7074471 L1274.84213,48.0816186 C1275.04967,48.2891523 1275.04967,48.6323811 1274.84213,48.8399147 C1274.73837,48.9476726 1274.59868,48.999556 1274.46298,48.999556 C1274.32729,48.999556 1274.1876,48.9436816 1274.08384,48.8399147 L1274.08384,48.8399147 L1269.70966,44.4657432 C1268.3607,45.6391068 1266.60065,46.3495105 1264.67697,46.3495105 C1260.44648,46.3495105 1257.00222,42.9052496 1257.00222,38.6747553 C1257.00222,34.4442609 1260.44249,31 1264.67697,31 Z M1264.67298,32.0775787 C1261.03715,32.0775787 1258.07581,35.0349337 1258.07581,38.6747553 C1258.07581,42.3145768 1261.03715,45.2759228 1264.67298,45.2759228 C1268.3128,45.2759228 1271.27016,42.3105858 1271.27016,38.6747553 C1271.27016,35.0389248 1268.3128,32.0775787 1264.67298,32.0775787 Z" id="Icons/Search"></path>
            </g>
        </g>
    </g>
</svg>
    );
};

export default React.memo(Search);
